import { ax } from '../../AxiosFactory'

const patchBlogLike = async (info) => {
  const res = await ax.patch('blog/update-like/', info)
  return res
}

export { patchBlogLike }
